module.exports = __webpack_public_path__ + "img/Logo_OJK.6d011dfd.png";